import { Component } from "../../core/Component";
import moment from "moment";
export class DateComponent extends Component {
  // static className = ["qform-row"];
  constructor($root, options) {
    super($root, options);
    this.messages = options.messages;
    this.fieldId = options.id;
    this.typeId = options.typeId;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "text";
    this.require = options.required === 1;
    this.placeholder = options.placeholder || " ";
    this.classes = options.classes || "";
    this.useDesign = options.useDesign;
    this.Datepicker = null;
    // установка пользовательских классов оформления
    this.wrapClasses = this.makeWrapUserClasses();
    /**
     * @type {Date | null}*/
    this.max = options.max ? new Date(options.max) : null;
    this.max?.setHours(23, 59, 59);

    /**
     * @type {Date | null}*/
    this.min = options.min ? new Date(options.min) : null;
    this.min?.setHours(0, 0, 0);
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formIndex}_${new Date().getTime()}`;
    this.datepickerId = `${options.name}_${options.formIndex}_datepicker_${new Date().getTime()}`;
    this.boxId = `${options.name}_${options.formIndex}_box_${new Date().getTime()}`;
    this.boxIdField = `${options.name}_${options.formIndex}_box-field_${new Date().getTime()}`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box_${new Date().getTime()}`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text_${new Date().getTime()}`;
    this.labelId = `${options.name}_${options.formIndex}_label_${new Date().getTime()}`;
    this.saveInStorage = this.options.data.saveInStorage;
  }
  toHTML() {
    return `
    <div class="qform-field datepickers qform_icon-date ${this.hint ? "qform-hint" : ""} ${this.wrapClasses?.join(" ")}" id="${this.boxId}">
      <div class="qform-field_wrap">
      ${this.toHtmlOutLabelBox()}
      <div class="qform-field__block">
        ${this.toHtmlAttBox("out_left")}
          <div class="qform-field__block_box">
            <div class="qform-field__block_box__field" id="${this.boxIdField}">
              ${this.toHtmlAttBox("in_left")}
              <div class="qform-field__block_box__field-box">
                <input
                  type="date"
                  class="qform-field__block_box__field-box_input datepicker-here ${this.classes}"
                  ${this.min ? `data-min="${new Date(this.min).toLocaleDateString()}"` : ""}
                  ${this.max ? `data-max="${new Date(this.max).toLocaleDateString(undefined, {
      timeZone: "GMT"
    })}"` : ""}
                  maxlength=10
                  data-active="0"
                  data-class_show=""
                  name="${this.name}"
                  id="${this.id}"
                  placeholder="${this.placeholder}"
                  ${this.require ? "required" : ""}
                >
                ${this.useDesign ? `<label for="${this.id}" class="qform-field__block_box__field-box_label">
                  ${this.label}
                  <span class="qform-field__importance-label">(${this.options.messages.unrequired})</span>
                  </label>` : ""}
              </div>
              ${this.toHtmlAttBox("in_right")}
            </div>
          </div>
          ${this.toHtmlAttBox("out_right")}
        </div>
      </div>
      ${this.toHtmlBottomBox()}
    </div>
    `;
  }
  dateParseToFormat(dateParsed) {
    const year = dateParsed.getFullYear();
    const month = dateParsed.getMonth() + 1;
    const date = dateParsed.getDate();
    return `${date < 10 ? "0" + String(date) : date}.${month < 10 ? "0" + String(month) : month}.${year}`;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /**
     * @type HTMLInputElement
     * */
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$input.disabled = disable;
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$boxField = this.$root.$el.querySelector(`#${this.boxIdField}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    if (!disable) {
      this.listeners = [{
        eventName: "change",
        method: "onChange",
        el: this.$input
      }, {
        eventName: "focus",
        method: "onFocus",
        el: this.$input
      }, {
        eventName: "blur",
        method: "onBlur",
        el: this.$input
      }, {
        eventName: "keydown",
        method: "onKeyDown",
        el: this.$input
      }, {
        eventName: "input",
        method: "onInput",
        el: this.$input
      }, {
        eventName: "paste",
        method: "onPaste",
        el: this.$input
      }];
    }
    super.init();
    this.min && (this.$input.min = moment(this.min).format("YYYY-MM-DD"));
    this.max && (this.$input.max = moment(this.max).format("YYYY-MM-DD"));
    const storedData = JSON.parse(localStorage.getItem(this.options.formId));
    if (storedData && storedData[this.name]) {
      this.$input.value = storedData[this.name];
    }
  }
  onChange(event) {
    event.preventDefault();
    this.$emit("Change:field", {});
    if (this.saveInStorage) {
      const storage = JSON.parse(localStorage.getItem(this.options.formId));
      if (storage) {
        storage[this.$input.name] = this.$input.value;
        localStorage.setItem(this.options.formId, JSON.stringify(storage));
      }
    }
  }
  onKeyDown(event) {}
  onInput(event) {}
  onPaste(event) {}
  onFocus() {
    this.$boxField.classList.add("qform-field-focus");
  }
  onBlur() {
    this.$boxField.classList.remove("qform-field-focus");
    this.setMassageValid();
    this.validation();
  }
  getValue() {
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: this.$input.value ? [new Date(this.$input.value).getTime()] : []
    };
  }
  async getDatePicker() {
    await import(/* webpackChunkName: "DatePickerComponent" */"./DatePicker.component").then(data => {
      this.Datepicker = new data.Qdatepicker(this.$input, this.boxIdField, {
        messages: this.messages
      });
      this.Datepicker.init();
    });
  }
  async setClassField(data) {
    // .open | .open-gap
    if (data && typeof data.formStyleDate !== "undefined" && data.formStyleDate.style !== 0) {
      if (data.formStyleDate.style === 1) {
        this.$input.dataset.class_show = "open";
      }
      if (data.formStyleDate.style === 2) {
        this.$input.dataset.class_show = "open-gap";
      }
    }
    if (!data.formStyleDate.useDesign) {
      //удаляем стилевые классы с корневого элемента
      let arrClass = this.$root.$el.classList.value.split(" ");
      arrClass.forEach(nameClass => {
        if (nameClass.trim()) {
          this.$root.$el.classList.remove(nameClass);
        }
      });
    }
    if (data && typeof data.formStyleFieldRequired !== "undefined") {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add("required");
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add("not-required");
      }
      if (!data.formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required");
        this.$box.classList.remove("not-required");
      }
    }
    if (data.formStyleDate.style > 0 && !this.Datepicker) {
      this.$input.readOnly = true;
      this.getDatePicker();
    }
  }
  validation() {
    let setMassageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let valid = false;
    if (this.require && this.$input.value.length === 0) {
      setMassageValid && this.setMassageValid(this.messages.inputRequired);
    } else if (this.max && new Date(this.$input.value).getTime() > this.max) {
      setMassageValid ? this.setMassageValid(this.messages.inputDateMax.replace("{0}", this.dateParseToFormat(this.max))) : null;
    } else if (this.min && new Date(this.$input.value).getTime() < this.min) {
      setMassageValid ? this.setMassageValid(this.messages.inputDateMin.replace("{0}", this.dateParseToFormat(this.min))) : null;
    } else {
      valid = true;
      this.setMassageValid();
    }
    //если условие верно - поле валидно, и в нем есть данные, граница становится зеленой
    this.setSuccessValid(valid && this.$input.value.length);
    return valid;
  }
}